import React from 'react';
import styles from '../../styles/product/users.module.css';
import * as statickImages from '../../statick-images';

class Users extends React.Component {
  constructor(props) {
    super(props);

    this.iconHome1 = statickImages['IconHome1'];
    this.iconHome2 = statickImages['IconHome2'];
    this.iconHome3 = statickImages['IconHome3'];
    this.iconHome4 = statickImages['IconHome4'];
  }

  render() {
    return (
      <section className={styles.usersSection}>
        <span id="whos-using-mashvisor" className={styles.anchor} />
        <header>
          <h2>Who’s Using Mashvisor?</h2>
        </header>
        <div className={styles.flexCont}>
          <div className={styles.rlPad}>
            <a href="/product/mashboard-first-time-investor/">
              <div className={styles.imgCont}>
                <this.iconHome1 />
              </div>
              <div className={styles.usersCat}>
                <h2>First-Time Real Estate Investors</h2>
                {/* <h3>New real estate investors usually don’t know where to begin their research. Mashvisor helps an investor quickly understand and analyze any city or neighborhood’s average investment performance. Investors are able to save time selecting the optimal area for investing and can save months worth of research deciding on this alone.</h3> */}
              </div>
            </a>
          </div>
          <div className={styles.rlPad}>
            <a href="/product/mashboard-experienced-investor/">
              <div className={styles.imgCont}>
                <this.iconHome2 />
              </div>
              <div className={styles.usersCat}>
                <h2>Experienced Real Estate Investors</h2>
                {/* <h3>Investors that are looking for their next property are used to analyzing their returns and having built many spreadsheets in the past. Mashvisor automatically calculates the returns of a property for the investor so that they never have to use a spreadsheet again.</h3> */}
              </div>
            </a>
          </div>
          <div className={styles.rlPad}>
            <a href="/product/mashboard-real-estate-agent/">
              <div className={styles.imgCont}>
                <this.iconHome3 />
              </div>
              <div className={styles.usersCat}>
                <h2>Real Estate Brokers/Agents</h2>
                {/* <h3>Real estate brokers and agents now have another place to advertise their properties. They can place their listings in front of investors and Mashvisor’s data helps the property better appeal to clients.</h3> */}
              </div>
            </a>
          </div>
          <div className={styles.rlPad}>
            <a href="/product/mashboard-property-manager/">
              <div className={styles.imgCont}>
                <this.iconHome4 />
              </div>
              <div className={styles.usersCat}>
                <h2>Property Managers</h2>
                {/* <h3>Real estate brokers and agents now have another place to advertise their properties. They can place their listings in front of investors and Mashvisor’s data helps the property better appeal to clients.</h3> */}
              </div>
            </a>
          </div>
        </div>
      </section>
    );
  }
}

export default Users;
